/**
 * Single source of truth for SubAccountant restriction UI translation keys and default (EN) labels.
 * When adding a new menu category or item:
 * 1. Add the key to menuRestrictionKeys.js (MENU_CATEGORIES or MENU_ITEMS and ITEM_TO_CATEGORY).
 * 2. Add an entry below to MENU_CATEGORY_LABELS or MENU_ITEM_LABELS (key -> default English label).
 * 3. Add the same key to translation EN/HE/AR files under "menuCategory.key" or "menuItem.key".
 *    Search for "SubAccountant restrictions" in each translation file to find the block.
 */

import { MENU_CATEGORIES, MENU_ITEMS } from './menuRestrictionKeys';

/** Default English labels for menu categories (restrictions UI). Key = same as MENU_CATEGORIES. */
export const MENU_CATEGORY_LABELS = {
  [MENU_CATEGORIES.Accounting]: 'Accounting',
  [MENU_CATEGORIES.Reports]: 'Reports',
  [MENU_CATEGORIES.Sales]: 'Sales',
  [MENU_CATEGORIES.Bank]: 'Bank',
  [MENU_CATEGORIES.Documents]: 'Documents',
  [MENU_CATEGORIES.Vehicles]: 'Vehicles',
  [MENU_CATEGORIES.Settings]: 'Settings',
};

/** Default English labels for menu items (restrictions UI). Key = same as MENU_ITEMS. */
export const MENU_ITEM_LABELS = {
  [MENU_ITEMS.AccountCardsTable]: 'Account Cards Table',
  [MENU_ITEMS.AccountCardDashboard]: 'Account Card Dashboard',
  [MENU_ITEMS.Incomes]: 'Incomes',
  [MENU_ITEMS.Expenses]: 'Expenses',
  [MENU_ITEMS.PaymentAcceptances]: 'Payment Acceptances',
  [MENU_ITEMS.PrintChecks]: 'Print Checks',
  [MENU_ITEMS.JournalEntries]: 'Journal Entries',
  [MENU_ITEMS.Projects]: 'Projects',
  [MENU_ITEMS.Assets]: 'Assets',
  [MENU_ITEMS.HoldingItems]: 'Holding Items',
  [MENU_ITEMS.DocumentsRequiringClarification]: 'Documents Requiring Clarification',
  [MENU_ITEMS.SortCodeReport]: 'Sort Code Report',
  [MENU_ITEMS.ClientExpenseAssignmentReport]: 'Expense Assignment Report',
  [MENU_ITEMS.TrialBalance]: 'Trial Balance',
  [MENU_ITEMS.ReportDetailedProfitAndLoss]: 'Profit & Loss Report',
  [MENU_ITEMS.ProfittAndLoss6111]: 'Profit and loss 6111',
  [MENU_ITEMS.Report1214]: '1214 report',
  [MENU_ITEMS.Report1214B]: 'Annex 1214B',
  [MENU_ITEMS.Report1281]: 'Annex 1281',
  [MENU_ITEMS.Report1362]: 'Annex 1362',
  [MENU_ITEMS.DebtorsCreditorsLedgerReport]: 'Debtors/Creditors Ledger',
  [MENU_ITEMS.ReceivablesAging]: 'Accounts Receivable Aging',
  [MENU_ITEMS.CashFlowForecast]: 'Cash Flow Forecast',
  [MENU_ITEMS.ForeignTravelReport]: 'Foreign Travel Report',
  [MENU_ITEMS.DownloadReceptionLog]: 'Reception Log',
  [MENU_ITEMS.AdvancesReport]: 'Advances Report',
  [MENU_ITEMS.PCNFile]: 'PCN File',
  [MENU_ITEMS.VATReport]: 'VAT Report',
  [MENU_ITEMS.WithholdingTaxReports]: 'Withholding Tax Reports',
  [MENU_ITEMS.ClientWithholdingTaxReports]: 'Client Withholding Tax',
  [MENU_ITEMS.Item856]: '856',
  [MENU_ITEMS.UniformFile]: 'Uniform File',
  [MENU_ITEMS.ReferenceSequence]: 'Reference Sequence',
  [MENU_ITEMS.DocumentItems]: 'Document Items',
  [MENU_ITEMS.InventoryManagement]: 'Inventory Management',
  [MENU_ITEMS.DeliveryNote]: 'Delivery Note',
  [MENU_ITEMS.ReturnNote]: 'Return Note',
  [MENU_ITEMS.TransactionDocuments]: 'Transaction Documents',
  [MENU_ITEMS.CancelDocuments]: 'Cancel Documents',
  [MENU_ITEMS.TaxInvoice]: 'Tax Invoice',
  [MENU_ITEMS.ReceiptTax]: 'Receipt (Tax)',
  [MENU_ITEMS.LawyerInvoice]: 'Lawyer Invoice',
  [MENU_ITEMS.LawyerReceipt]: 'Lawyer Receipt',
  [MENU_ITEMS.FixedPurchaseSale]: 'Fixed Asset Sale',
  [MENU_ITEMS.FixedPurchaseSaleReceipt]: 'Tax Invoice Receipt – Fixed Asset Purchase',
  [MENU_ITEMS.CreditNote]: 'Credit Note',
  [MENU_ITEMS.Receipt]: 'Receipt',
  [MENU_ITEMS.Transaction]: 'Transaction',
  [MENU_ITEMS.Quotation]: 'Quotation',
  [MENU_ITEMS.Order]: 'Order',
  [MENU_ITEMS.SelfInvoice]: 'Self Invoice',
  [MENU_ITEMS.VehicleManagement]: 'Vehicle Management',
  [MENU_ITEMS.BankMatching]: 'Bank Matching',
  [MENU_ITEMS.CardMatching]: 'Card Matching',
  [MENU_ITEMS.BankPages]: 'Bank Pages',
  [MENU_ITEMS.OtherDocuments]: 'Other Documents',
  [MENU_ITEMS.PermanentFile]: 'Permanent File',
  [MENU_ITEMS.SignatureDocuments]: 'Signature Documents',
  [MENU_ITEMS.Forms]: 'Forms',
  [MENU_ITEMS.EditClient]: 'Edit Client',
};

/** Translation key prefix for categories: t(`menuCategory.${categoryKey}`) */
export const MENU_CATEGORY_KEY_PREFIX = 'menuCategory';
/** Translation key prefix for items: t(`menuItem.${itemKey}`) */
export const MENU_ITEM_KEY_PREFIX = 'menuItem';
